import React from "react";
import LegalShell from "../components/LegalShell";

export default function Guidelines() {
  return (
    <LegalShell title="Community Guidelines" kicker="House rules" testid="page-guidelines">
      <p>Giffwurldaunce is a global dance community. To keep this space safe, fun, and respectful for dancers everywhere, every member must follow these rules.</p>

      <h3 className="text-cream font-black text-lg mt-6">✅ Encouraged</h3>
      <ul className="list-disc list-inside space-y-1">
        <li>Music, dance, food, fashion, language, and traditions from your island.</li>
        <li>Original content. Credit other creators when remixing or referencing.</li>
        <li>Constructive comments. Boost up-and-coming artists.</li>
      </ul>

      <h3 className="text-cream font-black text-lg mt-6 text-red-300">❌ Not allowed</h3>
      <ul className="list-disc list-inside space-y-1">
        <li><b>Hate speech</b> targeting race, ethnicity, religion, gender, sexuality, or disability.</li>
        <li><b>Harassment, bullying, threats, or doxxing.</b></li>
        <li><b>Nudity or sexual content.</b> No exceptions for minors.</li>
        <li><b>Violence, gore, or content that glorifies harm.</b></li>
        <li><b>Scams, fake accounts, or impersonation</b> of other people or brands.</li>
        <li><b>Copyright infringement.</b> Don't post music or video you don't have rights to.</li>
        <li><b>Spam, link-farming, or bot behaviour.</b></li>
        <li><b>Illegal activity</b> including drugs, weapons sales, or human trafficking.</li>
      </ul>

      <h3 className="text-cream font-black text-lg mt-6">Enforcement</h3>
      <p>Use the <b>Report</b> button to flag content. Our moderation team reviews reports within 48 hours. Violations may result in content removal, temporary suspension, or permanent ban depending on severity. Decisions can be appealed via support@giffwurldaunce.com.</p>

      <h3 className="text-cream font-black text-lg mt-6">Live streams</h3>
      <p>All Giffwurldaunce community guidelines apply to live streams. Streams are recorded and reviewable.</p>
    </LegalShell>
  );
}
